import './ApplicationsForm.css'
// import Lottie from 'react-lottie';
// import * as animationData from '../../../';
import IbanInput from '../../../utils/IbanInput/index'
import UploadFile from './UploadFile'
import { Button, Label, Input, Spinner } from 'reactstrap'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import WarningModal from './WarningModal'
import Header from '../../Header'
import ConditionsCheckBox from './ConditionsCheckBox'
import axios from 'axios'
import FormData from 'form-data'
import { capitalize } from '../../../utils/helpers'
import Loading from '../../Loading'
import { useDispatch, useSelector } from 'react-redux'
import { setFileNumber } from '../../../store/dosya_sayisi'

const ApplicationsForm = (props) => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [iban, setIban] = useState('')
  const [name, setName] = useState('')
  const [surname, setSurname] = useState('')
  const [files, setFiles] = useState([])
  const [filesPreview, setFilesPreview] = useState([])
  const [checkbox, setCheckbox] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [isModal, setIsModal] = useState({ type: '', active: false })
  const [customInputs, setCustomInputs] = useState(null)

  const file_number = useSelector((state) => state.FileNumber.value)

  const expr = /^TR\d{7}[0-9]{17}$/.test(iban)

  const dispatch = useDispatch()

  useEffect(() => {
    if (state) {
      setCustomInputs(JSON.parse(state?.custom_inputs))
      dispatch(setFileNumber(Number(state?.belge_sayisi)))
    }
    // eslint-disable-next-line
  }, [])

  const toggleWarningModal = (e) => {
    e.stopPropagation()
    setIsModal(!isModal)
  }

  const onFinish = (event) => {
    setLoading(true)
    if (name?.length < 2 || surname?.length < 2) {
      setLoading(false)
      setIsModal((prevState) => ({
        ...prevState,
        type: 'failed_name_surname',
        active: true,
      }))
      return false
    }
    if (!expr && iban?.length !== 26) {
      setLoading(false)
      setIsModal((prevState) => ({
        ...prevState,
        type: 'failed_iban',
        active: true,
      }))
      return false
    }
    if (files.length < Number(file_number)) {
      setLoading(false)
      setIsModal((prevState) => ({
        ...prevState,
        type: 'failed_files',
        active: true,
      }))
      return false
    }
    if (!checkbox) {
      setLoading(false)
      setIsModal((prevState) => ({
        ...prevState,
        type: 'failed_agreement',
        active: true,
      }))
      return false
    }

    event.currentTarget.disabled = true
    let formData = new FormData()
    formData.append('id', state?.basvuruId)
    formData.append('name', name)
    formData.append('surname', surname)
    formData.append('iban', iban)
    formData.append('custom_inputs', JSON.stringify(customInputs))
    formData.append('token', JSON.parse(localStorage.getItem('token')))
    for (let i = 0; i < files.length; i++) {
      formData.append('files[]', files[i])
    }
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/create`, formData)
      .then((res) => {
        if (res?.data.code === 200) {
          navigate('/success-applications', {
            state: { id: res?.data.result },
          })
          setLoading(false)
        } else if (res?.data.code === 400) {
          setErrorMessage(res.data.message)
          setIsModal((prevState) => ({
            ...prevState,
            type: 'server_error',
            title: res.data.title ? res.data.title : null,
            active: true,
          }))
          setLoading(false)
        }
      })
  }

  return (
    <>
      {loading ? (
        <Loading
          formText={'Belgeleriniz yükleniyor,'}
          text={'Lütfen bekleyiniz...'}
          formLodading={true}
        />
      ) : (
        <div className='hide-scrollbar'>
          <div
            style={{
              backgroundColor: '#fff',
              position: 'sticky',
              top: 0,
            }}
          >
            <Header onClick={() => navigate(-1)} />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={
                'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/' +
                state?.basvuru_fotografi
              }
              alt=''
              width={'90%'}
              style={{ borderRadius: '10px' }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
              marginTop: '1rem',
              marginBottom: '0.5rem',
              paddingLeft: '1rem',
              paddingRight: '1rem',
              paddingBottom: '0.5rem',
              fontSize: '0.9rem',
              fontStyle: 'italic',
              color: '#285843',
            }}
          >
            {state?.basvuru_aciklamasi}
          </div>
          <Label
            for='name'
            style={{
              paddingLeft: '1.4rem',
              color: '#285843',
              fontWeight: 'bold',
              fontSize: '0.9rem',
            }}
          >
            Banka Hesabı Sahibinin Adı
          </Label>
          <Input
            style={{
              width: '90vw',
              marginLeft: '1rem',
              marginBottom: '0.5rem',
              borderRadius: '20px',
            }}
            type='text'
            value={name}
            onChange={(e) => setName(capitalize(e))}
          />
          <Label
            for='surname'
            style={{
              paddingLeft: '1.4rem',
              color: '#285843',
              fontWeight: 'bold',
              fontSize: '0.9rem',
            }}
          >
            Banka Hesabı Sahibinin Soyadı
          </Label>
          <Input
            style={{
              width: '90vw',
              marginLeft: '1rem',
              marginBottom: '0.5rem',
              borderRadius: '20px',
            }}
            type='text'
            value={surname}
            onChange={(e) => setSurname(capitalize(e))}
          />
          <Label
            for='iban'
            style={{
              paddingLeft: '1.4rem',
              color: '#285843',
              fontWeight: 'bold',
              fontSize: '0.9rem',
            }}
          >
            IBAN Numaranız
          </Label>
          <IbanInput setIban={setIban} />

          {customInputs?.map((item) => {
            return (
              <React.Fragment key={item.id}>
                <Label
                  style={{
                    paddingLeft: '1.4rem',
                    color: '#285843',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                  }}
                >
                  {item.label}
                </Label>
                <Input
                  style={{
                    width: '90vw',
                    marginLeft: '1rem',
                    marginBottom: '0.5rem',
                    borderRadius: '20px',
                  }}
                  type='text'
                  placeholder={item.placeholder}
                  defaultValue={item.value}
                  onChange={(e) => {
                    let test = customInputs?.map((i) => {
                      if (i.id === item.id) {
                        console.log('item.id:', item.id)
                        console.log('i.id:', i)
                        i.value = e.target.value
                      }
                      return i
                    })
                    setCustomInputs(test)
                  }}
                />
              </React.Fragment>
            )
          })}

          <UploadFile
            setFiles={setFiles}
            files={files}
            filesPreview={filesPreview}
            setFilesPreview={setFilesPreview}
            setIsModal={setIsModal}
            setDocumentDescription={state?.belge_aciklama}
          />
          <div className='ms-4 mt-3'>
            <ConditionsCheckBox
              checkbox={checkbox}
              setCheckbox={setCheckbox}
              basvuru_sartlari_aciklama={state?.basvuru_sartlari_aciklama}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '1rem',
              marginBottom: '2rem',
            }}
          >
            <Button
              block
              onClick={onFinish}
              style={{
                marginLeft: '1rem',
                marginRight: '1rem',
                backgroundColor: '#285843',
              }}
            >
              {loading ? (
                <Spinner
                  size={'sm'}
                  // type="grow"
                />
              ) : (
                'Başvuruyu Tamamla'
              )}
            </Button>
          </div>
        </div>
      )}
      <WarningModal
        isModal={isModal.active}
        checkbox={checkbox}
        messageType={isModal.type}
        messageTitle={isModal?.title}
        iban={iban}
        expr={expr}
        files={files}
        name={name}
        surname={surname}
        errorMessage={errorMessage}
        toggleWarningModal={toggleWarningModal}
      />
    </>
  )
}

export default ApplicationsForm
